import { useCallback, DependencyList } from "react";
import { debounce, DebounceSettings, DebouncedFunc } from "lodash";

export function useDebounce<T extends (...args: any[]) => any>(
  callback: T,
  delay: number,
  options?: DebounceSettings,
  dependencies: DependencyList = [],
): DebouncedFunc<T> {
  return useCallback(debounce(callback, delay, options), dependencies); // eslint-disable-line react-hooks/exhaustive-deps
}
